import { render, staticRenderFns } from "./BtnBox.vue?vue&type=template&id=5956b03a"
import script from "./BtnBox.vue?vue&type=script&lang=js"
export * from "./BtnBox.vue?vue&type=script&lang=js"
import style0 from "./BtnBox.vue?vue&type=style&index=0&id=5956b03a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports